<mat-slide-toggle 
  [matTooltip]="userService.isDarkTheme ? ('settings.light_mode' | translate) : ('settings.dark_mode' | translate)"
  #darkModeSwitch 
  (change)="toggleTheme($event)" 
  [checked]="userService.isDarkTheme">
</mat-slide-toggle>